import { Link, useLocation } from 'react-router-dom'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { reExportedColors, Text } from '../1elements/'
import { establishOrRefreshSession } from '../../common/sessionGate'

const useStyles = makeStyles(() => ({
    root: {
        minHeight: 'auto'
    },
    rootDiv:{
        marginLeft: 60,
        height: '100vh',
        paddingTop: 18,
        paddingLeft: 12,
        paddingBottom: 13,
        paddingRight: 11,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    },
    tab: {
        borderRadius: '6px 6px 0px 0px',
        backgroundColor: `${reExportedColors.TABS}`, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        boxShadow: '0px 0px 3px #00000029',
        color: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        minHeight: '40px',
        minWidth: 82,
        padding: '8px 19px 15px',
    },
    active: {
        backgroundColor: reExportedColors.WHITE, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        color: reExportedColors.TEXT ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    },
    indicator: {
        backgroundColor: reExportedColors.WHITE, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        zIndex: 1,
    },
    content: {
        boxShadow: '0px 0px 3px #00000029',
        borderRadius: '0px 6px 6px 6px',
        marginLeft: 3,
        height: '86%',
        padding: '17px 22px 27px 21px',
        position: 'relative',
        overflowX: 'hidden'
    },
    scroller: {
        paddingTop: 5,
        paddingLeft: 3
    },
    goBackWrapper: {
        position: 'absolute',
        right: 0,
        top: 10
    },
    goBackButton: {
        borderRadius: '4px 0px 0px 4px',
        backgroundColor: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        transition: 'all 0.2s ease-in-out',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 28,
        height: 31,
        boxShadow: '0px 0px 3px #00000029',
    },
}))

const DataImportFormTabs= ({ children, flow }) => {
    const classes = useStyles()
    const location = useLocation()
    const allTabs = () => {
        switch(flow){
            case 'addClient':
                return [{label: 'Location', path: '/addClient/location'},
                    {label: 'People', path:'/addClient/people'},
                    {label:'Service', path:'/addClient/service'}]
            case 'addLocation':
                return [{label: 'Location', path: '/addLocation/location'},
                    {label: 'People', path:'/addLocation/people'},
                    {label:'Service', path:'/addLocation/service'}]
            case 'addPeople':
                return [{label: 'People', path:'/addPeople/people'}]
            case 'addService':
                return [{label:'Service', path:'/addService/service'}]
            default:
        }
    }


    return (
        <div className={classes.rootDiv}>
            <div>
                <Tabs value={location.pathname} classes={{ indicator: classes.indicator, root: classes.root, scroller: classes.scroller}}>
                    {allTabs().map((tab)=>(
                        <Tab key={tab.label} label={<Text type='tabHeader'>{tab.label}</Text>} value={tab.path} component={Link}
                             to={tab.path} classes={{root: classes.tab, selected: classes.active}} onClick={establishOrRefreshSession}
                             disabled/>
                    ))}
                </Tabs>
            </div>

            {/* back button for desktop */}
            <div className={classes.content}>
                {children}
            </div>
        </div>
    )
}

export default DataImportFormTabs
